// extracted by mini-css-extract-plugin
export default {"notification_indicator":"Navbar_notification_indicator__urgen","dropdown_notification":"Navbar_dropdown_notification__qV0c8"};